import { render, staticRenderFns } from "./OverviewPage.vue?vue&type=template&id=8d82305a&scoped=true&"
import script from "./OverviewPage.vue?vue&type=script&lang=ts&"
export * from "./OverviewPage.vue?vue&type=script&lang=ts&"
import style0 from "./OverviewPage.vue?vue&type=style&index=0&id=8d82305a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d82305a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VIcon,VLayout})
